// istanbul ignore file
export const loadProtobufClientProperties = (): Promise<typeof import('./getProtobufClientProperties')> =>
  import(/* webpackChunkName: "4-feat-protobuf-client-properties" */ './getProtobufClientProperties');
export const loadProtobufRequestFunctions = (): Promise<typeof import('./protobufRequestFunctions')> =>
  import(/* webpackChunkName: "4-feat-protobuf-request" */ './protobufRequestFunctions');
